import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@ds';
import {
  CHAT_LABEL_SHARE_MODAL_TITLE,
  CHAT_LABEL_WARNING_MODAL_BODY,
  CHAT_LABEL_CANCEL,
  CHAT_LABEL_WARNING_MODAL_CONFIRM,
} from '@features/components/Chat/constants';

type WarningModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  chatName: string;
  bodyText?: string;
};

export const WarningModal = ({ isOpen, onClose, onConfirm, chatName, bodyText }: WarningModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalContent className="rounded-2xl max-w-[500px] p-6 shadow-xl bg-white">
        <ModalHeader className="text-xl font-semibold text-gray-900">{CHAT_LABEL_SHARE_MODAL_TITLE}</ModalHeader>
        <div className="border-t border-gray-300 w-full mt-1 mb-4" />
        <ModalBody className="text-gray-700 text-base text-center px-6">
          <p>{bodyText ?? CHAT_LABEL_WARNING_MODAL_BODY(chatName)}</p>
        </ModalBody>
        <div className="border-t border-gray-300 w-full mt-4" />
        <ModalFooter className="flex justify-between gap-2 mt-4 w-full">
          <Button onClick={onClose} variant="outline" size="md" className="w-1/2">
            {CHAT_LABEL_CANCEL}
          </Button>
          <Button onClick={onConfirm} variant="solid" size="md" className="w-1/2">
            {CHAT_LABEL_WARNING_MODAL_CONFIRM}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
